import React from 'react';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import rideActions from '../../../actions/rides';
import { RouteMap } from './route-map';
import WrappedSpinner from '../../common/wrapped-spinner';

class BaseRouteMapContainer extends React.Component {
  componentDidMount() {
    const { tripId, tripRides, fetchRideWithRouteByTripId } = this.props;
    if (isUndefined(tripRides)) {
      if (tripId) fetchRideWithRouteByTripId(tripId);
    }
  }

  render() {
    const { isLoading: isRouteLoading, tripRides, zones } = this.props;

    // tripRides reducer should default to [] from server; case of isRouteLoading === false & tripRides === undefined shouldn't be reached
    const isLoading = isRouteLoading || isUndefined(tripRides);

    const featureCount = get(tripRides, 'route.features.length', 0);

    return (
      <WrappedSpinner isLoading={isLoading}>
        {featureCount <= 0 && (
          <div>This trip does not have any geo data.</div>
        )}
        {featureCount > 0 && (
          <RouteMap route={get(tripRides, 'route.features', [])} zones={zones} />
        )}
      </WrappedSpinner>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...rideActions,
}, dispatch);

const mapStateToProps = ({ rides }, { tripId, zones }) => ({
  isLoading: rides.isLoading,
  tripRides: get(rides, tripId),
  zones,
});

const RouteMapContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(BaseRouteMapContainer));
export { BaseRouteMapContainer, RouteMapContainer };
export default RouteMapContainer;
